import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { classicBusinessProjectShortcutRoute } from '@jira/router-routes__business-routes/src/classicBusinessProjectShortcutRoute.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { Redirect, type Route, type RouteContext } from '@atlassian/react-resource-router';
import { shortcutsPageEntrypoint } from './ui/spa/business/shortcut/index.tsx';

const classicBusinessProjectShortcutRedirect = ({
	match: {
		params: { projectKey },
	},
}: RouteContext): React.JSX.Element => {
	if (projectKey == null) {
		// This should never happen as if it wasn't matched, this won't be rendered unless someone re-used this component in a wrong route.
		throw Error('projectKey not found in match object of RouteContext');
	}
	return <Redirect to={`/browse/${String(projectKey)}`} />;
};

const NoopComponent = (): null => null;

export const classicBusinessProjectShortcutRouteEntry: Route = createEntry(
	classicBusinessProjectShortcutRoute,
	() => ({
		group: 'classic-business',
		isRedirect: expValEquals(
			'jira_redirect_business_shortcuts_to_project',
			'isEnabled',
			true,
			false,
		),
		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			() => expValEquals('jira_redirect_business_shortcuts_to_project', 'isEnabled', true, false),
			classicBusinessProjectShortcutRedirect,
			NoopComponent,
		),
		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		entryPoint: () =>
			expValEquals('jira_redirect_business_shortcuts_to_project', 'isEnabled', true, false)
				? undefined
				: shortcutsPageEntrypoint,
		supportsPreviewPanel: true,
		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
